// extracted by mini-css-extract-plugin
export default {"variantButtons":"ProductVariants_variantButtons__EXYHR","variantBtn":"ProductVariants_variantBtn__sGOhm","variantBtnText":"ProductVariants_variantBtnText__8hz3o"};